(() => {
  'use strict';
  const roots = [...document.querySelectorAll('[data-cbr-harrison]:not([data-cbr-initialized])')];
  if (!roots.length) return;
  roots.forEach(root => root.dataset.cbrInitialized = 'true');
  const liveRoots = roots.filter(root => root.dataset.editorPreview !== 'true');
  if (!liveRoots.length) return;
  // A server timestamp protects against a device clock behind the cached render.
  // A fresh same-origin HTTP Date header then anchors time independently of the device.
  let anchor = Math.max(Date.now(), ...liveRoots.map(r => Number(r.dataset.rendered) * 1000));
  let perf = performance.now();
  let timer;
  const now = () => anchor + performance.now() - perf;
  function update() {
    clearTimeout(timer);
    const t = now();
    let next = Infinity;
    liveRoots.forEach(root => {
      if (!root.isConnected) return;
      const start = Number(root.dataset.start) * 1000;
      const end = Number(root.dataset.end) * 1000;
      const supportEnd = Number(root.dataset.supportEnd) * 1000;
      const isHome = root.dataset.home === 'true';
      if (t < start || t >= supportEnd || (isHome && t >= end)) {
        root.hidden = true;
      } else if (t >= end) {
        root.querySelector('[data-cbr-offer]')?.remove();
        const template = root.querySelector('[data-cbr-support-template]');
        if (template) {
          root.append(template.content.cloneNode(true));
          template.remove();
        }
        root.hidden = !root.querySelector('[data-cbr-support]');
      } else {
        // Never turn an expired support-only server render back into a sales claim.
        root.hidden = !root.querySelector('[data-cbr-offer]');
      }
      for (const boundary of [start,end,supportEnd]) if (boundary > t) next = Math.min(next,boundary);
    });
    if (Number.isFinite(next)) timer = setTimeout(update, Math.min(next - t + 20, 60000));
  }
  update();
  fetch(location.pathname + '?cbr_rebate_clock=' + Date.now(), {
    method:'HEAD', cache:'no-store', credentials:'same-origin'
  }).then(response => {
    const serverDate = Date.parse(response.headers.get('date') || '');
    if (Number.isFinite(serverDate)) {
      anchor = serverDate;
      perf = performance.now();
      update();
    }
  }).catch(() => { /* Local/server-render clock guard remains active. */ });
  window.addEventListener('pageshow', update);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
})();
